import React, { Component } from 'react';
import Avatar from 'react-avatar-edit';
// import gql from 'graphql-tag';
import { /* Grid, */Button, Modal, Message } from 'semantic-ui-react';
// import { AuthClient } from '@emyw/core-lib';
import '../primitives.css';

/* const setAvatarMutation = gql`
    mutation ($profileId: Int!, $avatarBase64: String!) {
        setAvatar(profileId: $profileId, avatarBase64: $avatarBase64) {
            ok
            avatarUrl
            errors {
                path
                message
            }
        }
    }
`; */

class AvatarEditor extends Component {
  constructor(props, context) {
    super(props, context);
    this.onAvatarEditorClear = () => {
      this.setState({
        previewAvatar: null
      });
    };
    this.onAvatarEditorCrop = previewAvatar => this.setState({
      previewAvatar
    });
    this.onAvatarEditorOk = async () => {
      this.props.onAvatarUpdate(this.state.previewAvatar);
      this.onAvatarEditorClose();
      // const { previewAvatar } = this.state;
      // try {
      //     const { profile, onAvatarUpdate/* , onClose */ } = this.props;
      //     const response = await AuthClient.mutate({
      //         mutation: setAvatarMutation,
      //         variables: {
      //             profileId: profile.id,
      //             avatarBase64: previewAvatar,
      //         },
      //     });
      //     const { ok, /* avatarUrl, */ errors } = response.data.setAvatar;
      //     if (ok) {
      //         // onAvatarUpdate(avatarUrl);
      //         onAvatarUpdate(previewAvatar);
      //         // onClose();
      //         this.onAvatarEditorClose();
      //     } else {
      //         this.setState({ errors: [errors[0].message] });
      //     }
      // } catch (error) {
      //     this.setState({ errors: [error.message] });
      // }
    };
    this.onAvatarEditorClose = () => {
      this.setState({
        previewAvatar: null,
        src: null,
        errors: null
      });
      this.props.onClose();
    };
    this.state = {
      previewAvatar: null,
      src: null,
      errors: null
    };
  }
  render() {
    const {
      previewAvatar,
      errors
    } = this.state;
    const {
      open,
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
      open: open,
      closeOnDimmerClick: false,
      onClose: onClose,
      size: "small",
      className: "enjoyModal"
    }, /*#__PURE__*/React.createElement(Modal.Header, null, "Upload Profile Picture"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("div", {
      className: "avatarUpload"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Avatar, {
      width: 250,
      height: 250,
      onCrop: this.onAvatarEditorCrop,
      onClose: this.onAvatarEditorClear,
      src: this.state.src
    })), /*#__PURE__*/React.createElement("div", {
      className: "avatarPreview"
    }, /*#__PURE__*/React.createElement("img", {
      src: previewAvatar,
      alt: "Preview"
    }))), errors ? /*#__PURE__*/React.createElement(Message, {
      size: "small",
      error: true,
      header: "Trouble saving avatar image...",
      list: errors,
      className: "avatar_error_msg"
    }) : null), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      color: "grey",
      compact: true,
      onClick: this.onAvatarEditorClose /* onClose */
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      type: "button",
      primary: true,
      compact: true,
      disabled: !previewAvatar,
      onClick: this.onAvatarEditorOk
    }, "OK"))));
  }
}
export default AvatarEditor;